import React, { useState } from 'react';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx, useWidgetActions } from '../LayoutContext';
import { CommentsTab } from '../../CaseClient';

// Granular Case-surface widget — wraps the existing CommentsTab. Renders
// the comment composer + thread for the open case. No config; the inner
// component owns its own draft/internal state.

function CaseComments({ node }) {
  const { token, workspaceId, case: caseRow } = useLayoutCtx();
  const [refreshKey, setRefreshKey] = useState(0);
  useWidgetActions(node?.id, { refresh: () => setRefreshKey(k => k + 1) });

  if (!caseRow?.id) return null;
  return (
    <div style={{ padding: '20px' }}>
      <CommentsTab key={refreshKey} token={token} workspaceId={workspaceId} caseId={caseRow.id} />
    </div>
  );
}

registerWidget({
  type: 'case.comments',
  categories: ['case'],
  palette_label: 'Case comments',
  description: 'Comment composer (with internal/external toggle) plus the running comment thread for the open case.',
  Component: CaseComments,
  configSchema: null,
  publishes: ['xv.CommentAdded'],
  subscribes: ['xv.RefreshContext'],
  actions: [
    { name: 'refresh', label: 'Reload comments', description: 'Re-fetches the comment thread from the server.' },
  ],
  group: 'Case',
});
